import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import Groups2Icon from "@mui/icons-material/Groups2";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import HomeIcon from "@mui/icons-material/Home";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LogoutIcon from "@mui/icons-material/Logout";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import PendingIcon from "@mui/icons-material/Pending";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import TaskIcon from "@mui/icons-material/Task";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import PersonIcon from '@mui/icons-material/Person';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import ElectricBoltOutlinedIcon from '@mui/icons-material/ElectricBoltOutlined';
import EngineeringIcon from '@mui/icons-material/Engineering';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import GavelIcon from '@mui/icons-material/Gavel';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Tooltip, Collapse, Menu, MenuItem as MuiMenuItem } from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useTheme } from "@mui/system";
import * as React from "react";
import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import "./listItem.css";

export default function ListItems({ open = true }) {
  const { logout, auth } = useContext(AuthContext);
  const theme = useTheme();
  const location = useLocation();
  const [managementExpanded, setManagementExpanded] = React.useState(false);

  const textColor = theme.palette.text.primary;
  const iconColor = theme.palette.icon.primary;
  const primaryColor = theme.palette.primary.main;
  
  // Verificar se o usuário é admin (role 2019)
  const isAdmin = auth?.roles?.includes(2019);

  // Função para verificar se a rota está ativa
  const isActive = (path) => {
    // Para rotas com query params, comparar apenas o pathname
    const pathWithoutQuery = path.split('?')[0];
    return location.pathname === pathWithoutQuery || location.pathname === path;
  };

  // Função para verificar se alguma rota do submenu de Gestão está ativa
  const isManagementActive = () => {
    return location.pathname === '/manage' || 
           location.pathname.startsWith('/projects') ||
           location.pathname.startsWith('/integrators') ||
           location.pathname.startsWith('/power-companies') ||
           location.pathname.startsWith('/engineers') ||
           location.pathname.startsWith('/attorneys');
  };

  // Auto-expandir o menu de Gestão se estiver numa rota relacionada
  React.useEffect(() => {
    const shouldExpand = location.pathname === '/manage' || 
                        location.pathname.startsWith('/projects') ||
                        location.pathname.startsWith('/integrators') ||
                        location.pathname.startsWith('/power-companies') ||
                        location.pathname.startsWith('/engineers') ||
                        location.pathname.startsWith('/attorneys');
    
    if (shouldExpand) {
      setManagementExpanded(true);
    }
  }, [location.pathname]);

  // Componente de item de menu reutilizável
  const MenuItem = ({ to, icon: Icon, iconOutlined: IconOutlined, label, onClick }) => {
    const active = isActive(to);
    
    const itemStyles = {
      textDecoration: "none",
      color: active ? primaryColor : textColor,
      display: "block",
    };

    const buttonStyles = {
      py: 1.5,
      px: open ? 2 : 0,
      borderRadius: open ? "8px" : "0px",
      mx: open ? 1 : 0,
      my: 0.5,
      position: "relative",
      // No modo colapsado, remover background do item ativo
      backgroundColor: active && open 
        ? (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#F3F4F6') 
        : 'transparent',
      borderLeft: active ? `3px solid ${primaryColor}` : '3px solid transparent',
      transition: 'all 0.2s ease-in-out',
      display: 'flex',
      justifyContent: open ? 'flex-start' : 'center',
      '&:hover': {
        backgroundColor: open 
          ? (active 
            ? (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#F3F4F6')
            : (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : '#F9FAFB'))
          : 'transparent',
      },
    };

    const iconStyles = {
      color: active ? primaryColor : iconColor,
      minWidth: open ? "40px" : "auto",
      display: 'flex',
      justifyContent: 'center',
    };

    const textStyles = {
      '& .MuiListItemText-primary': {
        fontWeight: active ? 600 : 400,
        fontSize: "0.95rem",
      },
    };

    const content = (
      <ListItemButton sx={buttonStyles} onClick={onClick}>
        <ListItemIcon sx={iconStyles}>
          {active && Icon ? <Icon /> : IconOutlined ? <IconOutlined /> : <Icon />}
        </ListItemIcon>
        {open && <ListItemText primary={label} sx={textStyles} />}
      </ListItemButton>
    );

    // Envolver com Tooltip quando o menu estiver colapsado
    const wrappedContent = !open ? (
      <Tooltip title={label} placement="right" arrow>
        {content}
      </Tooltip>
    ) : content;

    return onClick ? (
      <Box sx={itemStyles}>{wrappedContent}</Box>
    ) : (
      <Link to={to} style={itemStyles}>
        {wrappedContent}
      </Link>
    );
  };

  // Componente de menu expansível (usado para Gestão)
  const ExpandableMenuItem = ({ icon: Icon, iconOutlined: IconOutlined, label, expanded, onToggle, children }) => {
    const active = isManagementActive();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const popupOpen = Boolean(anchorEl);

    const handleClick = (event) => {
      if (open) {
        // Menu expandido: comportamento normal de toggle
        onToggle();
      } else {
        // Menu retraído: abrir popup
        setAnchorEl(event.currentTarget);
      }
    };

    const handleClose = () => {
      setAnchorEl(null);
    };
    
    const buttonStyles = {
      py: 1.5,
      px: open ? 2 : 0,
      borderRadius: open ? "8px" : "0px",
      mx: open ? 1 : 0,
      my: 0.5,
      backgroundColor: active && open 
        ? (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#F3F4F6') 
        : 'transparent',
      borderLeft: active ? `3px solid ${primaryColor}` : '3px solid transparent',
      transition: 'all 0.2s ease-in-out',
      display: 'flex',
      justifyContent: open ? 'flex-start' : 'center',
      '&:hover': {
        backgroundColor: open 
          ? (active 
            ? (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#F3F4F6')
            : (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : '#F9FAFB'))
          : 'transparent',
      },
    };

    const iconStyles = {
      color: active ? primaryColor : iconColor,
      minWidth: open ? "40px" : "auto",
      display: 'flex',
      justifyContent: 'center',
    };

    const textStyles = {
      '& .MuiListItemText-primary': {
        fontWeight: active ? 600 : 400,
        fontSize: "0.95rem",
      },
    };

    const content = (
      <ListItemButton sx={buttonStyles} onClick={handleClick}>
        <ListItemIcon sx={iconStyles}>
          {active && Icon ? <Icon /> : IconOutlined ? <IconOutlined /> : <Icon />}
        </ListItemIcon>
        {open && (
          <>
            <ListItemText primary={label} sx={textStyles} />
            {expanded ? <ExpandLessIcon sx={{ color: active ? primaryColor : iconColor }} /> : <ExpandMoreIcon sx={{ color: active ? primaryColor : iconColor }} />}
          </>
        )}
      </ListItemButton>
    );

    const wrappedContent = !open ? (
      <Tooltip title={label} placement="right" arrow>
        {content}
      </Tooltip>
    ) : content;

    return (
      <Box>
        <Box sx={{ textDecoration: "none", color: active ? primaryColor : textColor }}>
          {wrappedContent}
        </Box>
        {open && (
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Box sx={{ pl: 2 }}>
              {children}
            </Box>
          </Collapse>
        )}
        {/* Menu popup quando retraído */}
        {!open && (
          <Menu
            anchorEl={anchorEl}
            open={popupOpen}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            PaperProps={{
              sx: {
                ml: 1,
                minWidth: 200,
              }
            }}
          >
            {React.Children.map(children, (child) => (
              <MuiMenuItem
                onClick={handleClose}
                component={Link}
                to={child.props.to}
                sx={{
                  py: 1.5,
                  px: 2,
                  '&:hover': {
                    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : '#F9FAFB',
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: '36px', color: iconColor }}>
                  {child.props.iconOutlined ? <child.props.iconOutlined fontSize="small" /> : null}
                </ListItemIcon>
                <ListItemText primary={child.props.label} />
              </MuiMenuItem>
            ))}
          </Menu>
        )}
      </Box>
    );
  };

  // Componente de subitem do menu expansível
  const SubMenuItem = ({ to, icon: Icon, iconOutlined: IconOutlined, label }) => {
    const active = isActive(to);
    
    const itemStyles = {
      textDecoration: "none",
      color: active ? primaryColor : textColor,
      display: "block",
    };

    const buttonStyles = {
      py: 1,
      px: 2,
      pl: 4,
      borderRadius: "8px",
      mx: 1,
      my: 0.25,
      backgroundColor: active 
        ? (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#F3F4F6') 
        : 'transparent',
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        backgroundColor: active 
          ? (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#F3F4F6')
          : (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : '#F9FAFB'),
      },
    };

    const iconStyles = {
      color: active ? primaryColor : iconColor,
      minWidth: "32px",
    };

    const textStyles = {
      '& .MuiListItemText-primary': {
        fontWeight: active ? 600 : 400,
        fontSize: "0.875rem",
      },
    };

    return (
      <Link to={to} style={itemStyles}>
        <ListItemButton sx={buttonStyles}>
          <ListItemIcon sx={iconStyles}>
            {active && Icon ? <Icon fontSize="small" /> : IconOutlined ? <IconOutlined fontSize="small" /> : <Icon fontSize="small" />}
          </ListItemIcon>
          <ListItemText primary={label} sx={textStyles} />
        </ListItemButton>
      </Link>
    );
  };

  // Definição de todos os itens do menu na ordem especificada
  const menuItems = [
    { to: "/home", icon: HomeIcon, iconOutlined: HomeOutlinedIcon, label: "Home", show: true },
    { to: "/activities", icon: TaskIcon, iconOutlined: TaskOutlinedIcon, label: "Atividades", show: true },
    { to: "/stages", icon: PendingIcon, iconOutlined: PendingOutlinedIcon, label: "Etapas", show: true },
    { to: "/activities-analysis", icon: AnalyticsIcon, iconOutlined: AnalyticsOutlinedIcon, label: "Análise de Atividades", show: isAdmin },
    { to: "/finances", icon: AccountBalanceIcon, iconOutlined: AccountBalanceOutlinedIcon, label: "Financeiro", show: true },
    { to: "/comissions", icon: AttachMoneyIcon, iconOutlined: AttachMoneyIcon, label: "Comissões", show: true },
    { to: "/meeting", icon: Groups2Icon, iconOutlined: Groups2OutlinedIcon, label: "Reunião", show: true },
  ];

  // Subitens do menu Gestão
  const managementSubItems = [
    { to: "/projects", icon: FolderIcon, iconOutlined: FolderOutlinedIcon, label: "Projetos", show: true },
    { to: "/integrators", icon: PersonIcon, iconOutlined: PersonOutlinedIcon, label: "Integradores", show: true },
    { to: "/power-companies", icon: ElectricBoltIcon, iconOutlined: ElectricBoltOutlinedIcon, label: "Concessionárias", show: true },
    { to: "/engineers", icon: EngineeringIcon, iconOutlined: EngineeringOutlinedIcon, label: "Engenheiros", show: true },
    { to: "/attorneys", icon: GavelIcon, iconOutlined: GavelOutlinedIcon, label: "Procurações", show: true },
  ];

  // Itens finais do menu
  const bottomMenuItems = [
    { to: "/template-checklist", icon: ChecklistRtlIcon, iconOutlined: ChecklistOutlinedIcon, label: "Templates Checklist", show: isAdmin },
    { to: "/whatsapp", icon: WhatsAppIcon, iconOutlined: WhatsAppIcon, label: "WhatsApp", show: true },
    { to: "/admin-panel", icon: AdminPanelSettingsIcon, iconOutlined: AdminPanelSettingsOutlinedIcon, label: "Painel do Adm", show: isAdmin },
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Menu items principais */}
      <Box sx={{ flexGrow: 1, overflowY: 'auto', overflowX: 'hidden' }}>
        {menuItems.map((item) => 
          item.show && (
            <MenuItem
              key={item.to}
              to={item.to}
              icon={item.icon}
              iconOutlined={item.iconOutlined}
              label={item.label}
            />
          )
        )}

        {/* Menu expansível Gestão */}
        <ExpandableMenuItem
          icon={BusinessCenterIcon}
          iconOutlined={BusinessCenterOutlinedIcon}
          label="Gestão"
          expanded={managementExpanded}
          onToggle={() => setManagementExpanded(!managementExpanded)}
        >
          {managementSubItems.map((item) =>
            item.show && (
              <SubMenuItem
                key={item.to}
                to={item.to}
                icon={item.icon}
                iconOutlined={item.iconOutlined}
                label={item.label}
              />
            )
          )}
        </ExpandableMenuItem>

        {/* Itens finais do menu */}
        {bottomMenuItems.map((item) => 
          item.show && (
            <MenuItem
              key={item.to}
              to={item.to}
              icon={item.icon}
              iconOutlined={item.iconOutlined}
              label={item.label}
            />
          )
        )}
      </Box>

      {/* Logout fixo na parte inferior */}
      <Box sx={{ mt: 'auto', pb: 2 }}>
        <MenuItem
          to="#"
          icon={LogoutIcon}
          iconOutlined={LogoutOutlinedIcon}
          label="Logout"
          onClick={logout}
        />
      </Box>
    </Box>
  );
}
